import React from 'react';
import ReactDOM from 'react-dom/client';
import RoutesHub from './components/functional/RoutHub';
import Layout from './components/ui/Layout';
import BasicAuth1 from './components/layers/BasicAuth1';
import HumanLayer1 from './components/layers/HumanLayer1';

const root = ReactDOM.createRoot(document.getElementById('_clc'));
root.render(
  <>
    <HumanLayer1>
      <BasicAuth1>
        <Layout>
          <RoutesHub />
        </Layout>
      </BasicAuth1>
    </HumanLayer1>
  </>
);